"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageAccessible__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "offset",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "length",
                type: "uint256",
            },
        ],
        name: "getStorageAt",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "targetContract",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "calldataPayload",
                type: "bytes",
            },
        ],
        name: "simulateAndRevert",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "0x6080604052348015600f57600080fd5b506102e08061001f6000396000f3fe608060405234801561001057600080fd5b50600436106100365760003560e01c80635624b25b1461003b578063b4faba0914610064575b600080fd5b61004e61004936600461011a565b610079565b60405161005b919061013c565b60405180910390f35b6100776100723660046101a0565b6100f7565b005b60606000610088836020610285565b67ffffffffffffffff8111156100a0576100a061018a565b6040519080825280601f01601f1916602001820160405280156100ca576020820181803683370190505b50905060005b838110156100ed57848101546020808302840101526001016100d0565b5090505b92915050565b600080825160208401855af480600052503d6020523d600060403e60403d016000fd5b6000806040838503121561012d57600080fd5b50508035926020909101359150565b602081526000825180602084015260005b8181101561016a576020818601810151604086840101520161014d565b506000604082850101526040601f19601f83011684010191505092915050565b634e487b7160e01b600052604160045260246000fd5b600080604083850312156101b357600080fd5b823573ffffffffffffffffffffffffffffffffffffffff811681146101d757600080fd5b9150602083013567ffffffffffffffff8111156101f357600080fd5b8301601f8101851361020457600080fd5b803567ffffffffffffffff81111561021e5761021e61018a565b604051601f8201601f19908116603f0116810167ffffffffffffffff8111828210171561024d5761024d61018a565b60405281815282820160200187101561026557600080fd5b816020840160208301376000602083830101528093505050509250929050565b80820281158282048414176100f157634e487b7160e01b600052601160045260246000fdfea2646970667358221220792734c95a5a80ad016d8da944c95b008982f4cc5f16c32e5a02c77bdbc7126764736f6c634300081b0033";
const isSuperArgs = (xs) => xs.length > 1;
class StorageAccessible__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.StorageAccessible__factory = StorageAccessible__factory;
//# sourceMappingURL=StorageAccessible__factory.js.map